<template>
  <div :style="{ position: 'relative' }">
    <Loading
      :active.sync="loading"
      :isFullPage="false"
      :zIndex="9000"
    ></Loading>
    <Toast :style="{ width: $isMobile() ? '100vw' : '' }" />
    <Dialog
      id="'dialog-confirm-data'"
      :visible.sync="localShow"
      :style="{ width: $isMobile() ? '100vw' : '40vw' }"
      v-bind:class="[{ 'p-dialog-maximized': $isMobile() }]"
      :modal="true"
      :header="'Enviar relatório para o cliente'"
    >
      <form
        name="validateForm"
        class="p-col-12"
        data-vv-scope="sendReportClient"
        @submit.prevent="validate"
      >
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12" style="margin-top: 10px">
            <span class="p-float-label">
              <InputText
                v-model="client_email"
                id="client_email"
                name="client_email"
                v-validate="'required|email'"
                data-vv-as="E-mail"
                data-vv-name="client_email"
                :class="{'p-invalid': errors.has('sendReportClient.client_email')}"
              />
              <label for="client_email">Email</label>
            </span>
            <small
              v-show="errors.has('sendReportClient.client_email')"
              class="p-error"
              role="alert"
            >
              {{ errors.first('sendReportClient.client_email') }}
            </small>
          </div>
          <div class="p-col-12 p-md-12" style="margin-top: 10px">
            <Checkbox
              v-model="check_existing"
              name="check_existing"
              id="check_existing"
              binary
            />
            <label for="check_existing">&nbsp; Guardar e-mail caso não esteja registado</label>
          </div>
        </div>
      </form>
      <template #footer>
        <Button
          :label="'Enviar Relatório'"
          icon="pi pi-envelope"
          class="p-button-success"
          @click="validate"
          :loading="loading"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="close"
          :disabled="loading"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import supportService from "../../services/support.service";

export default {
  name: "SendReportClient",
  $_veeValidate: {
    validator: "new",
  },
  props: ["show", "task_id"],
  components: { Loading },
  data() {
    return {
      localShow: false,
      loading: false,
      client_email: null,
      task: null,
      check_existing: true,
    };
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        this.localShow = newVal;
        if (newVal) {
          this.onDialogOpen();
        }
      }
    },
    localShow(newVal) {
      if (!newVal && this.show) {
        this.$emit("close");
      }
    }
  },
  methods: {
    async onDialogOpen() {
      await this.$nextTick();
      this.$validator.resume();
      this.errors.clear();
      this.$validator.reset();

      await this.getInterventionTask();
    },

    reset() {
      this.client_email = null;
      this.check_existing = true;
      this.loading = false;
      this.$validator.pause();
      this.errors.clear();
    },

    close() {
      this.reset();
      this.localShow = false;
    },

    async validate() {
      const isValid = await this.$validator.validateAll("sendReportClient");

      if (!isValid) {
        this.$toast.add({
          severity: "warn",
          summary: "Validação",
          detail: "Por favor, corrija os erros no formulário",
          life: 3000,
        });
        return;
      }

      return this.saveReport();
    },

    async getInterventionTask() {
      this.loading = true;
      try {
        const response = await supportService.getInterventionTask(this.task_id);

        if (!response) {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao obter dados",
            detail: "Ocorreu um erro ao obter dados da tarefa",
            life: 3000,
          });
          return;
        }

        this.task = response;

        if (this.task.pat?.client?.email) {
            this.client_email = this.task.pat.client.email.trim();
        }
      } catch (error) {
        console.error('Error fetching task:', error);
        this.$toast.add({
          severity: "error",
          summary: "Erro ao obter dados",
          detail: "Ocorreu um erro ao obter dados da tarefa",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },

    async saveReport() {
      this.loading = true;

      const data = {
        email: this.client_email,
        check_existing: this.check_existing
      };

      try {
        const response = await supportService.sendReportToClient(this.task_id, data);

        if (!response) {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao enviar relatório",
            detail: "Tente novamente mais tarde",
            life: 3000,
          });
          return;
        }

        this.$toast.add({
          severity: "success",
          summary: "Sucesso",
          detail: "E-mail enviado com sucesso",
          life: 3000,
        });

        this.$emit("addedReport", response);
        this.close();

      } catch (error) {
        console.error('Error sending report:', error);
        this.$toast.add({
          severity: "error",
          summary: "Erro ao enviar relatório",
          detail: "Tente novamente mais tarde",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.p-error {
  display: block;
  margin-top: 0.25rem;
}
</style>
